// --------------------------------------------------------------
// Created On: 2025-11-05
// Author: Hannah Vaughan
//
// Last Modified: 2025-12-05
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./DeviceEntry.module.scss";

// Input form for a device to be deactivated based on device type, identifier, and activation status.
export default function DeviceEntry(props: Props): Component {
  return (
    <div className="container mt-2 py-0">
      <div className={`${styles.deviceBody} row p-0 m-0`}>
        <div className="col py-2 pe-2">
          <div className="row align-items-center my-2 my-lg-1">
            <div className="col my-2 my-lg-1">
              <label className={`${styles.inputLabel} pb-1`}>Device Type</label>
              <select
                className="form-select"
                value={props.deviceTypeId}
                onChange={(e) =>
                  props.onChange(props.formId, parseInt(e.target.value, 10), props.identifier, props.activationStatus)
                }
              >
                <option value={-1} disabled>
                  Select device type...
                </option>
                {props.deviceTypes !== null &&
                  props.deviceTypes !== undefined &&
                  props.deviceTypes.map((deviceType) => (
                    <option key={deviceType.deviceTypeId} value={deviceType.deviceTypeId}>
                      {deviceType.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col my-2 my-lg-1">
              <label className={`${styles.inputLabel} pb-1`}>Identifier</label>
              <input
                type="text"
                className="form-control"
                value={props.identifier}
                onChange={(e) =>
                  props.onChange(props.formId, props.deviceTypeId, e.target.value, props.activationStatus)
                }
              />
            </div>
            <div className="col my-2 my-lg-1">
              <label className={`${styles.inputLabel} pb-1`}>Activation Status</label>
              <select
                className="form-select"
                value={props.activationStatus}
                onChange={(e) => props.onChange(props.formId, props.deviceTypeId, props.identifier, e.target.value)}
              >
                <option value="" disabled>
                  Select activation status...
                </option>
                <option value="Deactivated">Deactivated</option>
                <option value="Ready for activation">Ready for activation</option>
              </select>
            </div>
            <div className="col-auto">
              <button
                data-test="delete-deactivate-device-button"
                type="button"
                className="btn btn-danger float-end"
                onClick={() => props.onDelete(props.formId)}
              >
                <i className="fa fa-fw fa-times fa-xs" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  formId: number;
  deviceTypeId: number;
  identifier: string;
  activationStatus: string;
  deviceTypes: DeviceType[];
  disabled: boolean;
  onCreate: () => void;
  onChange: (formId: number, deviceTypeId: number, identifier: string, activationStatus: string) => void;
  onDelete: (formId: number) => void;
}

interface DeviceType {
  deviceTypeId: number;
  model: string;
  name: string;
}
